export default __webpack_public_path__ + "static/media/Exhaust-Gas-boiler.cbb39384.jpg";